import {
  Button,
  ButtonGroup,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { useRef } from "react";

type DeleteType = "manual" | "manualSection" | "comment";

type Props = {
  title?: string;
  deleteType: DeleteType;
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  isLoading?: boolean;
};

export function ConfirmDeleteModal({
  isOpen,
  onClose,
  onDelete,
  title,
  deleteType,
  isLoading = false,
}: Props) {
  const initialFocusRef = useRef(null);

  const getModalContent = () => {
    switch (deleteType) {
      case "comment":
        return {
          header: "Delete Comment?",
          body: (
            <>
              <Text>Are you sure you want to delete this comment?</Text>
              <Text>This action cannot be undone.</Text>
            </>
          ),
        };
      case "manualSection":
        return {
          header: "Delete Manual Section?",
          body: (
            <>
              <Text>
                Are you sure you want to delete the manual section &quot;
                {title}&quot;?
              </Text>
              <Text>
                All records will be unlinked, and the contents of this section
                will be lost.
              </Text>
            </>
          ),
        };
      case "manual":
        return {
          header: "Delete Manual?",
          body: (
            <>
              <Text>
                Are you sure you want to delete the manual &quot;
                {title}&quot;?
              </Text>
              <Text>
                All records will be unlinked, and the contents of this manual
                will be lost.
              </Text>
            </>
          ),
        };
      default:
        return {
          header: "Delete Item?",
          body: <Text>Are you sure you want to delete this item?</Text>,
        };
    }
  };

  const { header, body } = getModalContent();

  return (
    <Modal initialFocusRef={initialFocusRef} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <chakra-scope>
        <ModalContent>
          <ModalHeader>{header}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>{body}</ModalBody>
          <ModalFooter>
            <ButtonGroup>
              <Button
                ref={initialFocusRef}
                onClick={onClose}
                colorScheme="gray"
                isDisabled={isLoading}>
                Cancel
              </Button>
              <Button
                colorScheme="red"
                onClick={onDelete}
                isLoading={isLoading}
                loadingText="Deleting...">
                Delete
              </Button>
            </ButtonGroup>
          </ModalFooter>
        </ModalContent>
      </chakra-scope>
    </Modal>
  );
}
